import { createLogger } from '../config/logger';

const logger = createLogger('addressValidator');

/**
 * Validates an address using OpenStreetMap's Nominatim geocoding API
 * @param {string} address - The address to validate
 * @returns {Promise<{valid: boolean, error?: string, formattedAddress?: string}>}
 */
export const validateAddress = async (address) => {
    if (!address || !address.trim()) {
        return { valid: true }; // Address is optional, so empty is valid
    }

    const cleanAddress = address.trim();

    // Basic length check
    if (cleanAddress.length < 5) {
        return {
            valid: false,
            error: 'Address is too short. Please enter a complete address.',
        };
    }

    try {
        // Use OpenStreetMap Nominatim API (same as backend)
        const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(cleanAddress)}&limit=1`;
        
        const response = await fetch(url, {
            headers: {
                'User-Agent': 'LoyaltyTap/1.0 (support@loyaltap.com)',
            },
        });

        if (!response.ok) {
            throw new Error('Address validation service unavailable');
        }

        const data = await response.json();

        if (!data || data.length === 0) {
            return {
                valid: false,
                error: 'Address not found. Please enter a valid address.',
            };
        }

        // Address found - return formatted address if available
        const result = data[0];
        const formattedAddress = result.display_name || cleanAddress;

        return {
            valid: true,
            formattedAddress,
        };
    } catch (error) {
        // If validation fails due to network error, don't block submission
        // Log error but allow the address through (backend will handle it gracefully)
        logger.warn('Address validation error', { error });
        return {
            valid: true, // Allow submission even if validation fails
            error: undefined,
        };
    }
};

